import React, { Component } from "react";

import { Helmet } from "react-helmet";
import Rellax from "rellax";

import Hero from "components/PageHero/Hero";
import TextBlock from "components/TextBlock/TextBlock";
import TextBanner from "components/TextBanner/TextBanner";
import VacancyGrid from "components/Vacancy/VacancyGrid/VacancyGrid";
import VacancyGridItem from "components/Vacancy/VacancyGrid/VacancyGridItem";
import ArticleGrid from "components/ArticleGrid/ArticleGrid";
import ArticleGridItem from "components/ArticleGrid/ArticleGridItem";
import AboutItem from "components/AboutItem/About-Item";
import Button from "components/Button/Button";
import { MailGreen } from "assets/images/index.js";
import Robotica from "assets/images/Educatie/video-screenshots/screen-video-robotica.jpg";

import { I18n } from "react-i18next";

//Images
import Header from "assets/images/Vacatures/Overzicht/werken-bij-forever-plants.jpg";
import QuoteImage from "assets/images/Vacatures/Overzicht/foto-voor-onder-quote.jpg";
import VacancyOpen from "assets/images/Vacatures/Overzicht/open-sollicitatie.jpg";
import VacancyStudent from "assets/images/Vacatures/Overzicht/vacaturepagina-nog-student.jpg";
import VacancyScholier from "assets/images/Vacatures/Overzicht/scholieren.jpg";
import VacancyVerkoop from "assets/images/Vacatures/Overzicht/verkoopadministratie.png";
import VacancyLogistiek from "assets/images/Vacatures/Overzicht/afleverteam.jpg";
import Stage from "assets/images/Educatie/02_Voor-studenten/zoek-je-een-stage-nieuw.jpg";
import StageHq from "assets/images/Educatie/02_Voor-studenten/hq/zoek-je-een-stage-nieuw.jpg";
import Rondleiding from "assets/images/Educatie/02_Voor-studenten/rondleiding.jpg";
import RondleidingHq from "assets/images/Educatie/02_Voor-studenten/hq/rondleiding.jpg";
import Opdracht from "assets/images/Educatie/02_Voor-studenten/zoek-je-een-opdracht.jpg";
import OpdrachtHq from "assets/images/Educatie/02_Voor-studenten/hq/zoek-je-een-opdracht.jpg";

export default class Vacatures extends Component {
  componentDidMount() {
    document.body.classList.add("vacatures-overzicht");
    new Rellax(".vacatures-fpg-rellax", {
      speed: 4,
      center: false,
      round: true,
      vertical: true,
      horizontal: false,
    });
  }
  componentWillUnmount() {
    document.body.classList.remove("vacatures-overzicht");
  }
  render() {
    return [
      <Helmet key="head">
        <meta charSet="utf-8" />
        <title>
          Werken bij | Forever Plants | Samen de wereld vooruit helpen
        </title>
        <meta
          property="og:image"
          content={`${process.env.REACT_APP_SAFE_URL}${Header}`}
        />
        <meta
          name="description"
          content="Naast onze wens om planten te laten groeien willen we ook graag talent laten groeien. We zijn daarom vaak te vinden in het World Horti Centre en op verschillende Hoge Scholen. Forever Plants is het ideale bedrijf voor studenten die stage willen lopen, een opdracht zoeken of gewoon een rondleiding willen."
        />
        <meta
          property="og:description"
          content="Naast onze wens om planten te laten groeien willen we ook graag talent laten groeien. We zijn daarom vaak te vinden in het World Horti Centre en op verschillende Hoge Scholen. Forever Plants is het ideale bedrijf voor studenten die stage willen lopen, een opdracht zoeken of gewoon een rondleiding willen."
        />
      </Helmet>,
      <span className="vacatures-fpg-rellax" key="logo" />,
      <I18n>
        {(t, { i18n }) => (
          <main id="pageWrapper" key="content">
            <div className="wrapper-hero-video">
              <Hero
                imageSrc={Header}
                videoId="280943404"
                channel="vimeo"
                showSubtitle
              />
            </div>
            <div className="wrapper">
              <TextBlock
                extraClasses="text-vacatures"
                title={t("vacancyMainIntro")}
              >
                {t("vacancyMainBody")}
              </TextBlock>
              <Button className="btn" to="/blog/stigas-gezond-vitaal-werken" onClick="">
                  {t("homeSmartTellMeMore")}
                </Button>
            </div>
            <div className="wrapper-hero-video">
              <TextBanner
                extraClasses="flex flex-lbottom flex-column mt80"
                quoteImage={QuoteImage}
                quoteTitle={t("vacancyMainQuote")}
                quotePerson="Richard, Sales Forever Plants"
              />
            </div>
            <div className="wrapper">
              <TextBlock
                extraClasses="text-vacatures mt80"
                title={t("vacancyMainVacancyGrid")}
              />
              <VacancyGrid extraClasses="mt80" />
              <TextBlock
                id="student"
                extraClasses="text-education mt80"
                title={t("educationStudentTitle")}
                subtitle={t("educationStudentSubTitle")}
              />
              <ArticleGrid
                className="ArticleGrid ArticleGrid--information mt30 swiper-container"
                pagination={true}
              >
                <ArticleGridItem
                  imageSrc={Stage}
                  imageSrcHq={StageHq}
                  title={t("educationInternTitle")}
                  content={t("educationInternText")}
                  link="hallo@foreverplants.nl"
                />
                <ArticleGridItem
                  imageSrc={Rondleiding}
                  imageSrcHq={RondleidingHq}
                  title={t("educationTourTitle")}
                  content={t("educationTourText")}
                  link="hallo@foreverplants.nl"
                />
                <ArticleGridItem
                  imageSrc={Opdracht}
                  imageSrcHq={OpdrachtHq}
                  title={t("educationAssignmentTitle")}
                  content={t("educationAssignmentText")}
                  link="hallo@foreverplants.nl"
                />
              </ArticleGrid>
              <AboutItem
                informationMedia="wrapper-hero-video informationMedia informationMedia-video"
                channel="youtube"
                videoLink="MSK1aELKnHw"
                pictureURL={Robotica}
                informationContent="informationContent pl40"
                h3className="informationTitle"
                pClassName="informationParagraph mb50"
                Title={t("educationBeforeTitle")}
              >
                {t("educationBeforeText")}
                <br />
                <a
                  href="mailto:hallo@foreverplants.nl"
                  className="mailing-link mt10"
                >
                  <MailGreen /> hallo@foreverplants.nl
                </a>
              </AboutItem>
            </div>
          </main>
        )}
      </I18n>,
    ];
  }
}



// WEBPACK FOOTER //
// ./src/Pages/Vacatures.jsx